<template>
    <div class="nevs-content">
        <div class="nevs-content-top-buttons calendar-top-bar">
            <NevsButton class="primary" @click="addSession">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.addSession') }}
            </NevsButton>
            <NevsSelect width="180px" :ajax="'select/users'" nullable v-model="trainerId"></NevsSelect>
        </div>
        <NevsCard>
            <NevsCalendar :events="events" @range-change="loadEvents" @event-click="openSession"></NevsCalendar>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCalendar from "@/components/nevs/NevsCalendar.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";

export default {
    name: "ModuleCalendar",
    components: {NevsSelect, NevsCalendar, NevsButton, NevsCard},
    data() {
        return {
            events: [],
            lastRange: null,
            trainerId: null,
            // Set while the saved filter is being applied on load, so restoring it doesn't
            // immediately persist the same value back to the server.
            restoringFilter: false,
            crossTabHandle: null
        }
    },
    watch: {
        trainerId() {
            if (this.lastRange !== null) {
                this.loadEvents(this.lastRange);
            }
            if (this.restoringFilter) {
                this.restoringFilter = false;
                return;
            }
            this.saveTrainerFilter();
        }
    },
    methods: {
        loadEvents(range) {
            this.lastRange = range;
            let vm = this;
            let params = {start: range.start, end: range.end};
            if (this.trainerId !== null) {
                params.trainer_id = this.trainerId;
            }
            this.$API.APICall('get', 'sessions/calendar', params, (data, success) => {
                if (success) {
                    vm.events = data.events.map((event) => ({
                        id: event.id,
                        name: event.name,
                        start: event.start,
                        end: event.end,
                        color: event.color,
                        html: vm.buildEventHtml(event)
                    }));
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            }, false);
        },
        addSession() {
            this.$router.push('/sessions/0');
        },
        openSession(event) {
            let routeData = this.$router.resolve('/sessions/' + event.id);
            window.open(routeData.href);
        },
        buildEventHtml(event) {
            let lines = [];
            lines.push('<div>' + this.$LANG.Get('fields.trainer') + ': ' + event.trainer_name + '</div>');
            lines.push('<div>' + this.$LANG.Get('fields.room') + ': ' + event.room_name + '</div>');
            lines.push('<div>' + this.$LANG.Get('labels.attendance') + ': ' + event.attendance + ' / ' + event.capacity + '</div>');
            return lines.join('');
        },
        loadTrainerFilter() {
            let vm = this;
            this.$API.APICall('get', 'user-data', {key: 'calendar_trainer_filter'}, (data, success) => {
                if (success && data.data && typeof data.data.trainer_id !== 'undefined') {
                    let saved = data.data.trainer_id;
                    if (saved !== vm.trainerId) {
                        vm.restoringFilter = true;
                        vm.trainerId = saved;
                    }
                }
            }, false);
        },
        saveTrainerFilter() {
            this.$API.APICall('post', 'user-data', {
                key: 'calendar_trainer_filter',
                data: {trainer_id: this.trainerId}
            }, () => {}, false);
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'training');
        this.$store.commit('selectSubMenu', 'calendar');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.training'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.calendar'),
                link: null
            }
        ]);
        this.loadTrainerFilter();
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-calendar', () => {
            if (vm.lastRange !== null) {
                vm.loadEvents(vm.lastRange);
            }
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped>
.calendar-top-bar {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
}
</style>
